import { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'

import type {
  FacebookAdsErrorFromFacebook,
  FacebookAdsMetaStatus,
} from '@shared/api/rtkQuery'
import { formatDateTimeDisplay } from '@shared/lib/utils/time'
import { CreationAndExportStatus } from '@shared/model/constants/listStatus'
import ContactUs from '@shared/ui/ContactUs'

export const useFormatFacebookAdsExportStatus = () => {
  const { t } = useTranslation(['audience', 'common'])

  const formatFacebookAdsExportStatus = useCallback(
    (
      status: CreationAndExportStatus,
      updatedAt?: string,
      fbError?: FacebookAdsErrorFromFacebook,
      metaStatus?: FacebookAdsMetaStatus
    ) => {
      if (status === 'completed') {
        return (
          <>
            <Trans
              ns="audience"
              // 上次完成匯出時間：YYYY-MM-DD-HH-MM-SS
              i18nKey="export_audience_succeed"
              components={{
                Highlight: (
                  <Box
                    component="span"
                    sx={{
                      color: theme => theme.colors.brightBlue,
                      fontWeight: 500,
                    }}
                  />
                ),
              }}
              values={{
                updateAt: formatDateTimeDisplay(updatedAt ?? ''),
              }}
            />
            {(metaStatus === 'meta_processing' ||
              metaStatus === 'meta_unknown') && (
              <Box component="p" sx={{ mt: 0.5 }}>
                {t('audience:export.facebook_meta_status_label')}
                {t('common:punctuation.colon')}
                {metaStatus === 'meta_processing'
                  ? t('audience:export.facebook_meta_processing')
                  : t('audience:export.facebook_meta_unknown')}
              </Box>
            )}
          </>
        )
      }

      if (status === 'failed') {
        if (fbError) {
          return `FB ${fbError.message} - ${fbError.errorUserTitle} : ${fbError.errorUserMsg}`
        }

        return (
          <>
            {t('common:failure_export') + t('common:dot')}
            {t('common:please_try_again_or')}
            <ContactUs text={t('common:contact_us')} />
          </>
        )
      }

      return ''
    },
    [t]
  )

  return formatFacebookAdsExportStatus
}

export default useFormatFacebookAdsExportStatus
